/**
 * Art for the duel coin toss. The house coin is the shop token.
 * A cosmetic later registers another id; unknown ids stay on this one.
 */

export interface DuelCoinArt {
  id: string
  headsUrl: string
  /** Other face. Omit to stamp a reverse from the heads art. */
  tailsUrl?: string
}

export const HOUSE_DUEL_COIN: DuelCoinArt = {
  id: 'house-dragon',
  headsUrl: '/assets/ui/coin-token.webp',
}

/** App mark stamped on the reverse when a cosmetic does not supply its own. */
export const DUELING_CHAOS_MARK_URL = '/icons/icon.svg'

const COSMETIC_COINS = new Map<string, DuelCoinArt>()

/**
 * Resolve the coin a duel should flip. Pass a cosmetic id when one exists.
 */
export function duelCoinArt(id?: string | null): DuelCoinArt {
  if (id) {
    const owned = COSMETIC_COINS.get(id)
    if (owned) return owned
  }
  return HOUSE_DUEL_COIN
}

/** Room for a future cosmetic catalog to add a coin without touching the toss. */
export function registerDuelCoin(art: DuelCoinArt): void {
  COSMETIC_COINS.set(art.id, art)
}
